import { connect } from 'react-redux';
import JobListView from './job_list_view';
import {
  getCurrentUser,
  getCandidateJobListingIds,
  getCandidateTotalJobListings,
  getCandidateJobListingsLoaded,
  getCandidateJobListingsLoading,
  getCandidateJobListingsFilters,
  getCandidateJobListingsSearch,
  getCandidateAppliedJobIds,
  getCandidateSavedJobIds,
  getCandidateAppliedJobsLoaded,
  getCandidateAppliedJobsLoading,
  getCandidateSavedJobsLoaded,
  getCandidateSavedJobsLoading,
  getCandidateJobListingsZipcode,
  getCandidateJobListingsDistance,
} from '../../../reducer';
import {
  listFilteredJobPostingsForCandidate,
  setCandidateJobListingsSearch,
  listFilteredJobApplicationsForCandidate,
  setCandidateJobListingsZipcode,
  setCandidateJobListingsFilters,
} from '../../../solve/actions';

// Pull specific state out of the Redux store that you need to render
// this component's view using this function.
// Do not retrieve any state that is not used directly by the view.
// Do not associate full objects when all you need are Ids.
// Let child components pull their own properties.
//
// mapStateToProps(state, { prop })
const mapStateToProps = (state, { mode }) => {
  let jobs;
  let loaded;
  let loading;
  let total = 0;
  switch (mode) {
    case 'saved':
      jobs = getCandidateSavedJobIds(state);
      loaded = getCandidateSavedJobsLoaded(state);
      loading = getCandidateSavedJobsLoading(state);
      total = getCandidateSavedJobIds(state).size;
      break;
    case 'applied':
      jobs = getCandidateAppliedJobIds(state);
      loaded = getCandidateAppliedJobsLoaded(state);
      loading = getCandidateAppliedJobsLoading(state);
      total = getCandidateAppliedJobIds(state).size;
      break;
    case 'all':
    default:
      jobs = getCandidateJobListingIds(state);
      loaded = getCandidateJobListingsLoaded(state);
      loading = getCandidateJobListingsLoading(state);
      total = +getCandidateTotalJobListings(state);
  }
  return {
    currentUser: getCurrentUser(state),
    jobs,
    total,
    loaded,
    loading,
    zipCode: getCandidateJobListingsZipcode(state),
    distance: getCandidateJobListingsDistance(state),
    filters: getCandidateJobListingsFilters(state),
    search: getCandidateJobListingsSearch(state),
  };
};

// Wire up specific actions using this function. If you directly map an
// action creator, it will be automatically wrapped with `dispatch()`,
// so do not define new functions here unless you need to override or
// explicitly specify a parameter of an action creator based on the
// nature of the component or its props.
//
// mapDispatchToProps(dispatch, { prop })
const mapDispatchToProps = {
  listFilteredJobPostingsForCandidate,
  listFilteredJobApplicationsForCandidate,
  setCandidateJobListingsZipcode,
  setCandidateJobListingsFilters,
  setSearch: setCandidateJobListingsSearch,
};

const JobListContainer = connect(mapStateToProps, mapDispatchToProps)(JobListView);

export default JobListContainer;
